import React from "react";
import { Card, Columns, Stack, Text } from "@shopify/polaris";
import { Field } from "react-final-form";
import ActionField from "../../StockTypeAndOptions/components/ActionField.js";
import NotifySection from "../../StockTypeAndOptions/components/NotifySection/NotifySection.js";

import {
    PRODUCTS_NO_ACTION,
    PRODUCTS_ACTION_PUSH_DOWN_VISIBLE,
    PRODUCTS_ACTION_VISIBLE
} from "../../../../../../../../constants/productActionTypes.js";

const actionOptions = [
    { label: "Make product visible", value: PRODUCTS_ACTION_VISIBLE },
    { label: "Push back up product", value: PRODUCTS_ACTION_PUSH_DOWN_VISIBLE },
    { label: "No action", value: PRODUCTS_NO_ACTION }
];

const UnusedProductsCard = () => {
    return (
        <Card>
            <Card.Section>
                <Columns columns={{ xs: "1fr 1fr" }}>
                    <Stack distribution={"fill"} vertical>
                        <Field name="unusedProductsBasedOnAttributes" component={ActionField} options={actionOptions} />
                    </Stack>
                </Columns>
            </Card.Section>
        </Card>
    );
};

export default UnusedProductsCard;